import { useContext } from 'react';

import { CalendarContext } from '@pages/Calendar/context/CalendarContext';

export const useCalendarContext = () => {
  const context = useContext(CalendarContext);

  if (!context) {
    throw new Error(
      'useCalendarContext must be used within a CalendarProvider'
    );
  }

  return context;
};
